import { Switch, Route, Redirect } from 'react-router-dom';

import { PageAuth } from '../pages/page-auth/page-auth';
import { PageMain } from '../pages/page-main/page-main';
import { PageError } from '../pages/page-error/page-error';

// const empty = { path: '/empty' };

export const Router = ({ logined }) => {
  // console.log('router logined', logined);
  // const Page = logined ? <PageMain /> : <PageAuth />;

  return (
    <Switch>
      {logined ? (
        <Route path="/" exact>
          <PageMain />
        </Route>
      ) : (
        <Route path="/" exact>
          <PageAuth />
        </Route>
      )}
      <Route path="/error">
        <PageError />
      </Route>
      <Redirect
        to={{
          pathname: '/error',
        }}
        push={true}
      />
      {/* <Switch>
        <RoutePublic exact path="/" component={Auth} defaultPath={defaultPath} />
        <RoutePublic path="/auth" component={Auth} defaultPath={defaultPath} />

        <Layout sections={sections}>
          <Switch>
            {getRoutes()}
            <Redirect to="/auth" />
          </Switch>
        </Layout> */}
      {/* <Redirect to="/auth" />
      </Switch> */}
    </Switch>
  );
};
